import ViewModuleIcon from "@material-ui/icons/ViewModule";

export const ProgramIcon = ViewModuleIcon;
export { ProgramCreate } from "./create";
export { ProgramEdit } from "./edit";
export { ProgramList } from "./list";
